import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { Zap } from 'lucide-react';

export function LandingHeader({ onQuickClock }) {
  const { t } = useTranslation();
  
  return (
    <header className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold">RS</span>
          </div>
          <span className="font-bold text-xl text-slate-900" style={{ fontFamily: 'Manrope' }}>
            ReStaff
          </span>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <Button
            variant="outline"
            onClick={onQuickClock}
            className="flex items-center border-orange-200 text-orange-600 hover:bg-orange-50 text-xs sm:text-sm px-2 sm:px-4"
            data-testid="quick-clock-btn"
          >
            <Zap size={16} className="mr-1 sm:mr-2 flex-shrink-0" />
            <span>{t('landing.nav.quickClock')}</span>
          </Button>
          <Link to="/login">
            <Button variant="ghost" className="text-xs sm:text-sm px-2 sm:px-4" data-testid="login-btn">
              {t('landing.nav.login')}
            </Button>
          </Link>
          <Link to="/register" className="hidden md:block">
            <Button data-testid="get-started-btn">{t('landing.hero.cta')}</Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
